// extracted by mini-css-extract-plugin
export default {"container":"src-components-Layouts-Element-css__container--gJuxm"};